module.exports = __webpack_public_path__ + "static/media/shape.ca13a32c.svg";